var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 77,
    rx: 15,
    fill: "url(#paint0_linear_344_156)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3334 25.6665V35.6665H47.3334",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 52.3335V42.3335H30.6666",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.85 34C25.6952 31.6113 27.1318 29.4756 29.0257 27.7923C30.9196 26.109 33.2091 24.9329 35.6804 24.3737C38.1518 23.8145 40.7246 23.8905 43.1586 24.5946C45.5927 25.2986 47.8087 26.6078 49.6 28.4L57.3333 35.6666M20.6666 42.3333L28.4 49.6C30.1912 51.3921 32.4072 52.7013 34.8413 53.4053C37.2754 54.1094 39.8481 54.1854 42.3195 53.6262C44.7909 53.067 47.0803 51.8909 48.9742 50.2076C50.8681 48.5243 52.3047 46.3887 53.15 44",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_156",
    x1: 72,
    y1: 74,
    x2: 5,
    y2: 5.50001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BE7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.f55d988fe69659e667c84f362401e9b4.svg";
export { ForwardRef as ReactComponent };